/** */
export const ADD_SELECTED_PLAN = 'add selected plan to store.';

export const addSelectedPlan = (payload) => ({
  type: ADD_SELECTED_PLAN,
  payload
});
